import { render } from "./linkComponent.vue?vue&type=template&id=5dcf592a&ts=true"
import script from "./linkComponent?vue&type=script&lang=ts"
export * from "./linkComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__